import BusinessInformationStore from './BusinessInformationStore'

export default BusinessInformationStore
